import { render, staticRenderFns } from "./ChatLocationV2.vue?vue&type=template&id=2b3e53bc&scoped=true"
import script from "./ChatLocationV2.vue?vue&type=script&lang=js"
export * from "./ChatLocationV2.vue?vue&type=script&lang=js"
import style0 from "./ChatLocationV2.vue?vue&type=style&index=0&id=2b3e53bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e53bc",
  null
  
)

export default component.exports